export const MEETINGS_GRID_SIZE = 4;

/** Pad to four slots so the 2×2 grid always reserves space for four meetings. */
export function buildMeetingGridSlots<T>(meetings: T[]): (T | null)[] {
  if (meetings.length === 0) return [];
  const slots: (T | null)[] = [...meetings];
  if (slots.length < MEETINGS_GRID_SIZE) {
    while (slots.length < MEETINGS_GRID_SIZE) {
      slots.push(null);
    }
  }
  return slots;
}
